/**
 * Constants for unit conversions
 */

export const CU_CM_TO_CU_IN = 0.061023744;
export const KG_TO_LBS = 2.20462262185;
